import { Close as CloseIcon } from '@mui/icons-material';
import { Alert as AlertMui, Button, Collapse, IconButton, styled } from '@mui/material';
import { AlertProps } from './type';

const PREFIX = 'Alert';

const classes = {
  root: `${PREFIX}-root`,
  button: `${PREFIX}-button`,
  alert: `${PREFIX}-alert`,
};

const StyledCollapse = styled(Collapse)(({ theme }) => ({
  [`&.${classes.root}`]: {
    marginBottom: theme.spacing(2),
    '& .MuiAlert-root': {
      borderWidth: 2,
    },
  },

  [`& .${classes.button}`]: {
    marginLeft: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },

  [`& .${classes.alert}`]: {
    display: 'flex',
    alignItems: 'center',
    '&.MuiAlert-outlinedError': {
      color: theme.palette.error.pink,
      borderColor: theme.palette.error.pink,
      borderLeft: `3px solid ${theme.palette.grey[200]}`,
    },
    '&.MuiAlert-outlinedSuccess': {
      color: theme.palette.secondary[500],
      borderColor: theme.palette.secondary[500],
    },
    '&.MuiAlert-outlinedError .MuiButton-text': {
      color: theme.palette.error.main,
    },
    '&.MuiAlert-outlinedError .MuiButton-contained': {
      color: 'white',
      backgroundColor: theme.palette.error.main,
    },
  },
}));

const Alert = (props: AlertProps) => {
  const {
    isAlertVisible,
    children,
    actions,
    icon,
    severity,
    variant,
    autoClose,
    onClose,
    'data-testid': testId,
  } = props;

  const Actions = () => {
    // If autoClose is provided the actions property will be ignored
    if (autoClose) {
      return (
        <IconButton aria-label="close" color="inherit" size="small" onClick={onClose}>
          <CloseIcon fontSize="inherit" />
        </IconButton>
      );
    }

    if (actions) {
      return (
        <>
          {actions.map(action => (
            <Button
              key={action.label}
              className={classes.button}
              onClick={action.callback}
              {...action.buttonProps}
            >
              {action.label}
            </Button>
          ))}
        </>
      );
    }
    return <></>;
  };

  return (
    <StyledCollapse in={isAlertVisible} className={classes.root}>
      <AlertMui
        variant={variant}
        severity={severity}
        action={<Actions />}
        icon={icon}
        className={classes.alert}
        data-testid={testId}
      >
        {children}
      </AlertMui>
    </StyledCollapse>
  );
};

export default Alert;
